import { graphqlClient } from "@/core/api/graphql/client";
import { MergeCartDocument } from "@/core/api/graphql/types";
import { Logger } from "@/core/utilities";
import { BRL_REPLACEMENT_CURRENCY_CODE } from "@/core/utilities/brlCurrency";
import type { MergeCartMutation, MergeCartMutationVariables } from "@/core/api/graphql/types";

/**
 * Asks the server to convert the user's BRL carts to USD. It is the sign-in `mergeCart` mutation without a guest cart;
 * USD is sent explicitly so no empty BRL cart is created. Failures are logged and never thrown.
 */
export async function convertBrlCartsToUsd(params: {
  storeId: string;
  userId: string;
  cultureName?: string;
}): Promise<void> {
  try {
    await graphqlClient.mutate<MergeCartMutation, MergeCartMutationVariables>({
      mutation: MergeCartDocument,
      variables: {
        command: { ...params, currencyCode: BRL_REPLACEMENT_CURRENCY_CODE, secondCartId: "" },
      },
    });
  } catch (error) {
    Logger.error("Failed to convert BRL carts to USD", error);
  }
}
